import api from 'services/api'
import { AxiosResponse } from 'axios'

type SendCodeRequestProps = {
  ds_emai: string
}

type SendCodeResponse = {
  id_usua: number
  nm_usua?: string
  return_code: number
  return_chav: string
}

export const sendCodeRequest = async ({
  ds_emai
}: SendCodeRequestProps): Promise<SendCodeResponse> => {
  const response = await api.post<SendCodeRequestProps, AxiosResponse<SendCodeResponse>>(
    `autenticacao/send-code`,
    { ds_emai }
  )

  return response.data
}

type ValidateCodeRequestProps = {
  id_usua: number
  ds_cod_senh: string
}

type ValidateCodeResponse = {
  id_usua: number
  nm_usua?: string
  return_code: number
  return_chav: string
}

export const validateCodeRequest = async (
  props: ValidateCodeRequestProps
): Promise<ValidateCodeResponse> => {
  const response = await api.post<
    ValidateCodeRequestProps,
    AxiosResponse<ValidateCodeResponse>
  >(`autenticacao/validate-code`, props)

  return response.data
}

type ResetPasswordRequestProps = {
  id_usua: number
  ds_senh_nova: string
  ds_confirm_senha: string
  ds_cod_senh: string
}

type ResetPasswordResponse = {
  id_usua: number
  return_code: number
  return_chav: string
}

export const updatePasswordRequest = async (props: ResetPasswordRequestProps) => {
  const response = await api.post<
    ResetPasswordRequestProps,
    AxiosResponse<ResetPasswordResponse>
  >(`autenticacao/update-password`, props)

  return response.data
}

export type SecurityParameters = {
  cd_parm: number
  ds_parm: string
  vl_parm: string
  return_code: number
  return_chav: string
}

export const listSecurityParameters = async () => {
  const response = await api.get<null, AxiosResponse<SecurityParameters[]>>(
    `autenticacao/security-parameters`
  )

  return response.data
}
